(function() {
    const selectors = {
        form: document.querySelector('[data-actiontype="ehi-core/aem65/components/form/actions/directpostgma"]'),
        errorBanner: '.cmp-form-container-error__message',
        fieldError: 'Email address invalid or duplicate'
    };

    var bannerTextDefault = '';

    function scrollToError(location) {
        window.scroll({ top: location, behavior: 'smooth' });          
    }

    function resetGMOErrors() {
        selectors.form.removeAttribute('data-cmp-gma-error');
        selectors.form.removeAttribute('data-show-error');
        selectors.form.removeAttribute('data-invalid');
        selectors.form.querySelector(selectors.errorBanner).innerHTML = bannerTextDefault;

        var basicError = selectors.form.querySelectorAll('.cmp-form-text--invalid');
        [].forEach.call(basicError, function(el) {
            el.className = el.className.replace("cmp-form-text--invalid", "");
        });

        var fieldError = selectors.form.querySelectorAll('.gma-error');
        [].forEach.call(fieldError, function(el) {
            el.className = el.className.replace("gma-error", "");
        });

        var fieldLabel = selectors.form.querySelectorAll('.cmp-form-text__gma-error');
        [].forEach.call(fieldLabel, function(el) {
            el.parentElement.removeChild(el);
        });            
    }

    // find banner and toggle error text
    function gmoError(type, errorMsg) {
        if ( type == 'banner' ) {
            selectors.form.setAttribute('data-cmp-gma-error', '');
            selectors.form.querySelector(selectors.errorBanner).innerHTML = errorMsg;
    
            if (!selectors.form.dataset.invalid) {
                selectors.form.dataset.invalid = true;
                selectors.form.dataset.showError = true;
                selectors.form.querySelector(selectors.errorBanner).focus();
            }

            if ( window.innerWidth < 640 ) {
                scrollToError(selectors.form.getBoundingClientRect().top + window.scrollY);
            }
        }
        if ( type == 'field' ) {
            selectors.form.querySelectorAll('input[type="email"]')
            for ( var i = 0; i < selectors.form.querySelectorAll('input[type="email"]').length; i++ ) {
                var errorCopy = document.createElement('p');
                errorCopy.className = 'cmp-form-text__error cmp-form-text__gma-error';
                if ( errorMsg ) {
                    errorCopy.innerHTML = errorMsg;
                } else {
                    errorCopy.innerHTML = selectors.fieldError;
                }

                selectors.form.querySelectorAll('input[type="email"]')[i].classList.add('cmp-form-text--invalid', 'gma-error');
                if ( selectors.form.querySelectorAll('input[type="email"]')[i].parentElement.getElementsByClassName('cmp-form-text__gma-error').length == 0 ) {
                    selectors.form.querySelectorAll('input[type="email"]')[i].parentElement.insertBefore(errorCopy, selectors.form.querySelectorAll('input[type="email"]')[i].nextSibling);
                }
            }
        }
    }

    function bindFormSubmit() {
        var thisBtn = selectors.form.querySelector('button[type="submit"]');

        if ( thisBtn ) {
            if ( selectors.form.querySelector(selectors.errorBanner).textContent ) {
                bannerTextDefault = selectors.form.querySelector(selectors.errorBanner).textContent;
            }

            thisBtn.addEventListener('click', function(event) {
                if ( selectors.form.checkValidity() == false ) {
                    resetGMOErrors();
                }
            });

            selectors.form.addEventListener('submit', function(event) {
                resetGMOErrors();
                event.preventDefault();

                // AJAX call to servlet goes here because validation has been found true
                var ajaxReturn = false;

                var fetchURL = '/bin/cheerios/gma-direct-post';
                const queryString = new URLSearchParams(new FormData(this)).toString()

                fetch('/libs/granite/csrf/token.json', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })                    
                .then(response => response.json())
                .then(data => { 
                    fetch(fetchURL, {
                        method: 'POST',
                        body: queryString,
                        headers: {
                            'CSRF-Token': data.token,
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                    }).then(response => {
                        response.json().then(data => {
                            // parse data here
                            if ( data.messages && data.messages.length > 0 ) {
                                // error message returned from endpoint - use enterprise.i18nReservation and messages
                                gmoError('banner', data.messages[0].message);

                                // Check for submit trigger for field error
                                if ( selectors.form.hasAttribute('data-cmp-gma-validation') ) {
                                    if ( selectors.form.hasAttribute('data-cmp-gma-errorArray') ) {
                                        var errorCodeText = JSON.parse(selectors.form.getAttribute('data-cmp-gma-errorArray'));

                                        for ( var i = 0; i < errorCodeText.length; i++ ) {
                                            if ( data.messages[0].code == errorCodeText[i][0] ) {
                                                gmoError('field', errorCodeText[i][1]);
                                            }                                            
                                        }
                                    } else {
                                        // set to default text since i18n not found
                                        gmoError('field');
                                    }                                    
                                }

                            }

                            if ( data.message ) {
                                // display return error from servlet if failure there
                                gmoError('banner', data.message);
                            }

                            if ( data.individual ) {
                                // Success - Redirect back to success page using hidden attribute
                                var redirectURL = selectors.form.querySelector('input[name=":redirect"]').value;
                                window.location.href = redirectURL;                                
                            }
                        })
                    }).catch(error => {
                        selectors.form.querySelector(selectors.errorBanner).innerHTML = "Form did not submit correctly, please try again."});                    
                })
                .catch(error => selectors.form.querySelector(selectors.errorBanner).innerHTML = "Form did not submit correctly, please try again.");
            });
        }
        
    }

    function onDocumentReady() {
        if ( selectors.form ) {
            // action type set to GMA post so enable submit override
            bindFormSubmit();
        }
    }

    if (document.readyState !== "loading") {
        onDocumentReady();
    } else {
        document.addEventListener("DOMContentLoaded", onDocumentReady);
    }

})();